import aponeo from './aponeo';
import { addToBasketFunctions } from './basket';
import { addDetailLinkFunctions } from './detailLink';
import { addToLeafletFunctions } from './leaflet';

export default () => {
  // infinite scrolling product list
  if ($('#products-grid').length && window.apn_ajax_list) {
    (() => {
      const $window = $(window),
        productsElem = $('#products-grid');
      let sIndex = window.apn_ajax_list.page_size,
        pageSize = window.apn_ajax_list.page_size,
        isDataAvailable = true,
        hasScrolled = false,
        isBusy = false;

      // run the load handler every couple of ms instead of every pixel
      $(window).scroll(() => {
        hasScrolled = true;
      });
      window.setInterval(() => {
        if (!hasScrolled || isBusy || !isDataAvailable) {
          return;
        }

        hasScrolled = false;
        isBusy = true; // set busy state early

        // use bottom of the div as reference
        const top = productsElem.offset().top,
          bottom = productsElem.height(),
          triggerOffset = 500;
        if (top + bottom - triggerOffset > $window.scrollTop() + $window.height()) {
          isBusy = false; // reset busy when exit early
          return;
        }

        aponeo.showLoadingScreen();
        $.ajax({
          type: 'GET',
          url:
            '/rpc.php?action=' +
            window.apn_ajax_list.model +
            '&start=' +
            sIndex +
            '&offset=' +
            pageSize +
            '&design=responsive',
        })
          .done((result) => {
            productsElem.append(result);

            sIndex = sIndex + pageSize;

            //When data is not available
            if (!result) {
              isDataAvailable = false;
            }
          })
          .always(() => {
            isBusy = false;
            aponeo.hideLoadingScreen();
            addToLeafletFunctions();
            addToBasketFunctions();
            addDetailLinkFunctions();
          });
      }, 250);
    })();
  }

  /** Sortieren Select-Element in Produktlisten **/
  $('._product_ssort').change((event) => {
    window.location.href = $(event.target).find(':selected').data('value');
  });

  // Display Aponeo's Choice Batch
  const filterPopulatity = new RegExp('sort=0').exec(window.location.href);
  const filterActive = new RegExp('sort=').exec(window.location.href);
  const pagingActive = new RegExp('seite').exec(window.location.href);
  if ((filterPopulatity || !filterActive) && !pagingActive) {
    $('.col-12:nth-child(-1n + 2) > .apn-product-list-item--list .apn-product-list-item-advice').addClass(
      'js-apn-advice',
    );
  }

  /** Dropdown Filter Prevent Scrolling of Body **/
  const dropdownFilterButton = $('#dropdown-filter');
  if ($(dropdownFilterButton).length) {
    (() => {
      const body = $('body'),
        dropdownFilterContent = $('#dropdown-content-filter'),
        dropdownFilterCloseButtons = $('.js-close-dropdown-filter'),
        dropdownFilterOpenedClass = 'show',
        isLocked = 'isLocked';

      function toggleBodyLockOnClick() {
        $(dropdownFilterButton).on('click touch', () => {
          $(body).addClass(isLocked);
        });

        $(dropdownFilterCloseButtons).on('click touch', () => {
          $(body).removeClass(isLocked);
        });
      }

      if (window.innerWidth < 992) {
        toggleBodyLockOnClick();
      }

      $(window).resize(function () {
        if (window.innerWidth < 992) {
          toggleBodyLockOnClick();

          // prevent body from scrolling when filter is opened and viewport is smaller than 992 => especially when resizing down from viewports greater than 992
          if ($(dropdownFilterContent).hasClass(dropdownFilterOpenedClass)) {
            $(body).addClass(isLocked);
          }
        } else if (window.innerWidth >= 992) {
          // unbind click event on dropdownFilterButton that may got initialized on window width smaller than 992 beforehand to prevent locking the body
          // allow body to scroll as it should never be locked on window width greater than 992
          $(dropdownFilterButton).off('click touch');
          $(body).removeClass(isLocked);
        }
      });
    })();
  }

  /**
   * Fetch and place product variants on `partial_product_list_packagegroup.tpl`
   * when there is no concrete product loaded already
   */
  if ($('.productlist-combi_element.tab-pane').length) {
    $('.productlist-combi__navi [data-concrete-product-id]').on('click touch', (event) => {
      const $tabNavButton = $(event.target);
      const concreteProductId = $tabNavButton.data('concrete-product-id');
      const completeProductId = $tabNavButton.data('complete-product-id');
      const $productContentWrapper = $(`.productlist-combi_element[id=${completeProductId}]`);
      const $activeProduct = $('.productlist-combi_element.active.show');
      const activeProductHeight = $($tabNavButton.closest('.tab-content').find($activeProduct)).height();

      if (!$productContentWrapper.length || !concreteProductId || !completeProductId) return;

      // remove empty spaces inside $productContentWrapper div
      const $trimmedProductContentWrapper = $.trim($productContentWrapper.html());

      if (!$trimmedProductContentWrapper.length) {
        $.ajax({
          type: 'GET',
          url: `/rpc.php?action=productoverview&id=${concreteProductId}`,
          beforeSend: () => {
            // prevent layout shifts by adding height of currently active product
            $productContentWrapper.css('min-height', activeProductHeight);
            aponeo.showLoadingScreen();
          },
        })
          .done((result) => {
            $productContentWrapper.html(result);
            $productContentWrapper.attr('data-loaded', true);
          })
          .always(() => {
            _initializeUIFunctions();
            aponeo.hideLoadingScreen();
          });
      }
    });

    const _initializeUIFunctions = () => {
      addToLeafletFunctions();
      addToBasketFunctions();
      addDetailLinkFunctions();
    };
  }
};
